// import SelfService from './SelfService';

export default {
  // component: SelfService,
  component: load(() => import(/* webpackChunkName: "Feed-SelfService" */ './SelfService')),
  priority: 12,
  permissions: ['FeedingConsoleMenu/SelfServiceMenu'],
  name: app.translate('routes.home.feed.SelfService'),
  icon: 'domain',
  drawer: true,
};


